var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTaskless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.985,
    height: 126.28,
    viewBox: "0 0 94.985 126.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-taskless",
    transform: "translate(-59.885 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_98_",
    transform: "translate(59.885 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M63.619,46.656h87.517a3.734,3.734,0,0,1,3.734,3.734V157.01a3.736,3.736,0,0,1-3.734,3.736H63.619a3.734,3.734,0,0,1-3.734-3.734V50.39a3.734,3.734,0,0,1,3.734-3.734Z",
    transform: "translate(-59.885 -34.465)",
    fill: "#007a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M82.255,67.813h83.294V170.846H82.255Z",
    transform: "translate(-76.41 -50.094)",
    fill: "#eeefee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M118.9,134.47H103.371V119.9H118.9Zm-12.7-2.649h9.882v-9.269h-9.882Z",
    transform: "translate(-92.008 -88.574)",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M184.5,127.011h51.31V129.6H184.5Z",
    transform: "translate(-151.938 -93.824)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M184.5,158.635h28.449v2.592H184.5Z",
    transform: "translate(-151.938 -117.184)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M118.9,251.658H103.371V237.087H118.9Zm-12.7-2.649h9.882v-9.273h-9.882Z",
    transform: "translate(-92.008 -175.137)",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M184.5,244.2h51.31v2.592H184.5Z",
    transform: "translate(-151.938 -180.388)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M184.5,275.824h28.449v2.592H184.5Z",
    transform: "translate(-151.938 -203.752)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M118.9,368.841H103.371V354.27H118.9Zm-12.7-2.649h9.882v-9.273h-9.882Z",
    transform: "translate(-92.008 -261.7)",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M184.5,361.378h51.31v2.592H184.5Z",
    transform: "translate(-151.938 -266.951)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M184.5,393.008h28.449V395.6H184.5Z",
    transform: "translate(-151.938 -290.316)",
    fill: "#dbd8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M197.967,21.661l-3.2-9.769a5.491,5.491,0,0,0-5.236-3.776h-7.764a7.744,7.744,0,0,0-15.471-.741q-.016.344,0,.689v.052H158.53a5.459,5.459,0,0,0-5.211,3.776l-3.2,9.769Z",
    transform: "translate(-126.541 -0.001)",
    fill: "#575b6d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.48,
    cy: 3.48,
    r: 3.48,
    transform: "translate(42.965 8.349) rotate(-67.486)",
    fill: "#eeefee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaskless);
export default __webpack_public_path__ + "static/media/icon-taskless.d113e887c3c5debea75a6eca3f55b225.svg";
export { ForwardRef as ReactComponent };